// layouts/StudentLayout.js
import StudentSidebar from "../components/student/StudentSidebar";
// import StudentBottomNav from "../components/student/StudentBottomNav"; // optional
import { Outlet, useNavigate } from "react-router-dom";
import { auth } from "../firebase/firebaseConfig";

export default function StudentLayout() {
  const navigate = useNavigate();
  const handleLogout = async () => {
    await auth.signOut();
    navigate("/login");
  };

  return (
    <div className="role-theme-surface flex min-h-screen bg-bg text-text relative">
      <StudentSidebar onLogout={handleLogout} />
      <div className="flex-1 min-h-screen p-4 md:ml-0 pb-16">
        <div className="mx-auto max-w-5xl">
          <Outlet />
        </div>
      </div>
      {/* <StudentBottomNav /> */}
    </div>
  );
}
